import qs from 'qs'
import { setNoValidClientToast, setUnauthenticatedToast } from '@/composables/unauthenticatedToast'
import { router } from '@/plugins/router'
import * as ls from '@/services/localStorage'
import * as userService from '@/services/userService'
import axios, { AxiosError } from 'axios'
 
import { toRaw } from 'vue'

const accessTokenKey = process.env.VUE_APP_LS_ACCESS_TOKEN_KEY

let currentClientIdForHeader: string | null = null

export function setCurrentClientIdForHeader(id: string | null) {
  currentClientIdForHeader = id
}

axios.interceptors.response.use(
  async (response) => {
    if (response.headers['x-force-reload-client'] === 'true') {
      window.dispatchEvent(new CustomEvent('force-reload-client'))
    }
    return response
  },
  (error: AxiosError<any>) => {
    if (error.response?.headers['x-force-reload-client'] === 'true') {
      window.dispatchEvent(new CustomEvent('force-reload-client'))
    }
    if (error.response?.status === 401) {
      setUnauthenticatedToast()
      userService.logout(router)
      return new Promise(() => {})
    }

    if (
      error.response?.status === 403 &&
      error.response?.data?.code === 'NO_VALID_CLIENT'
    ) {
      setNoValidClientToast()
      userService.logout(router)
      return new Promise(() => {})
    }

    if ((error.response?.status && error.response?.status >= 500) || error.code === 'ERR_NETWORK') {
      console.log('error 500', error)
    } else if (error.response?.status && error.response?.status >= 404) {
      console.log('error 404', error)
    }

    if (
      error.response?.data?.errorMessage === 'The method or operation is not implemented.' ||
      error.response?.data?.ClassName === 'System.NotImplementedException'
    ) {
      error.response.data.isNotImplemented = true
    }

    throw error
  },
)

axios.interceptors.request.use(async (event) => {
  event.headers.setContentType('application/json')
  event.headers.setAuthorization(`Bearer ${ls.get(accessTokenKey)}`)
  event.headers['Access-Control-Allow-Origin'] = '*'
  event.params = {
    ...toRaw(event.params),
    culture: getLanguage(),
  }

  event.paramsSerializer = { indexes: true }

  const url = event.url || ''
  if (!url.includes('/users/login') && currentClientIdForHeader) {
    event.headers['X-Current-Client-Id'] = currentClientIdForHeader
  }

  return event
})

const getLanguage = () => {
  const language = ls.get(process.env.VUE_APP_LS_LANGUAGE_KEY)
  switch (language) {
    case 'pt':
      return 'pt-BR'
    case 'en':
      return 'en-US'
    case 'es':
      return 'es'
    default:
      return 'pt-BR'
  }
}

export default axios
